<!-- <div class="card" @fadeInOut>
  <div class="title">
    <span>{{Notification.title}}</span>
  </div>
  <div class="content">
    <span>{{Notification.value}}</span>
  </div>
  <div class="footer d-flex">
    <div>
      <sit-icon class="d-md-flex" [icon]="Icon.CalendarIconNotify"
                alt="Icono tipo de notificación" [sizeClass]="'icon-size-12'"></sit-icon>
      {{Notification.date}}
    </div>

    <div>
      <sit-icon class="d-md-flex" [icon]="Icon.LocationIconNotify"
                alt="Icono tipo de notificación" [sizeClass]="'icon-size-12'"></sit-icon>
      {{Notification.location}}
    </div>
  </div>

</div> -->

<ng-container *ngIf="dataSource | async as data; else loading">

  <div *ngFor="let item of data; let index = index" class="card-info" [class.cursor-pointer]="hasDispatcher()"
      [class.fx-cell-hover]="hasDispatcher()" (click)="handleCardAction(item, index)">

      <div class="container-message">
          <div class="card-icon">
            <sit-icon [icon]="item['icon']" [sizeClass]="'icon-size-40'" class="d-flex"></sit-icon>
          </div>

            <div class="card-body">
              <h5>{{ item['title'] }}</h5>
              <h2>{{ item['statusValue'] }}</h2>
              <div class="footer-info">
                <div class="d-flex gap-8-px align-items-center">
                  <sit-icon [icon]="Icon.calendar_y" class="d-flex" [sizeClass]="'icon-size-24'"></sit-icon>
                  <span>{{ item['detectedDate'] | date:'dd/MM/yyyy - hh:mm' }}</span>
                </div>
                <div class="d-flex gap-8-px align-items-center">
                  <sit-icon [icon]="Icon.location_y" class="d-flex" [sizeClass]="'icon-size-24'"></sit-icon>
                  <span>{{ item['name'] }}</span>
                </div>
              </div>
            </div>
        </div>


    </div>

</ng-container>



<ng-template #loading>
  <sit-spinner />
</ng-template>
